import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { RequestInterceptor } from './types';
import { getSessionOutHeader } from '../utils/headers';

/**
 * 检测登陆是否失效
 * @param config
 * @returns
 */
function checkSessionOut(config: AxiosRequestConfig) {
  return getSessionOutHeader(config) === '1';
}

/**
 * 阻止请求拦截器
 */
export default class AbortRequestInterceptor implements RequestInterceptor {
  /** 是否登陆失效 */
  isSessionOut = false;

  /**
   * 处理请求
   * @param config
   * @returns
   */
  handleRequest(config: AxiosRequestConfig) {
    console.log(config.url, 'abort');
    return config;
  }

  /**
   * 处理响应信息
   * @param response
   * @returns
   */
  handleResponse(response: AxiosResponse) {
    const isSessionOut = checkSessionOut(response.config);
    // 登陆失效，终止流程
    if (isSessionOut) {
      this.isSessionOut = true;
      return this.abortRequest();
    }
    return response;
  }

  /**
   * 对于登陆失效引发的报错，终止流程
   * @param error
   * @returns
   */
  handleResponseError(error: AxiosError) {
    if (axios.isCancel(error) && this.isSessionOut) {
      return this.abortRequest();
    }
    return Promise.reject(error);
  }

  /**
   * 终止流程
   * @returns
   */
  abortRequest() {
    return new Promise(() => { }) as Promise<any>;
  }
}
